export default "__VITE_ASSET__C9GYk8$E__"